declare namespace $ {

	type $mol_search__query_shm_list_page_1 = $mol_type_enforce<
		ReturnType< $shm_list_page['filter'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__hint_shm_list_page_2 = $mol_type_enforce<
		ReturnType< $shm_list_page['filter_hint'] >
		,
		ReturnType< $mol_search['hint'] >
	>
	type $shm_list_head__title_shm_list_page_3 = $mol_type_enforce<
		ReturnType< $shm_list_page['title'] >
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__head_content_shm_list_page_4 = $mol_type_enforce<
		ReturnType< $shm_list_page['head_content'] >
		,
		ReturnType< $shm_list_head['head_content'] >
	>
	type $shm_list_head__filter_shm_list_page_5 = $mol_type_enforce<
		ReturnType< $shm_list_page['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__Filter_shm_list_page_6 = $mol_type_enforce<
		ReturnType< $shm_list_page['Search'] >
		,
		ReturnType< $shm_list_head['Filter'] >
	>
	type $shm_list_head__add_title_shm_list_page_7 = $mol_type_enforce<
		ReturnType< $shm_list_page['add_title'] >
		,
		ReturnType< $shm_list_head['add_title'] >
	>
	type $shm_list_head__add_content_shm_list_page_8 = $mol_type_enforce<
		ReturnType< $shm_list_page['add_content'] >
		,
		ReturnType< $shm_list_head['add_content'] >
	>
	type $shm_list_head__add_shm_list_page_9 = $mol_type_enforce<
		ReturnType< $shm_list_page['add_run'] >
		,
		ReturnType< $shm_list_head['add'] >
	>
	type $shm_list_head__close_hint_shm_list_page_10 = $mol_type_enforce<
		ReturnType< $shm_list_page['close_hint'] >
		,
		ReturnType< $shm_list_head['close_hint'] >
	>
	type $shm_list_head__close_content_shm_list_page_11 = $mol_type_enforce<
		ReturnType< $shm_list_page['close_content'] >
		,
		ReturnType< $shm_list_head['close_content'] >
	>
	type $shm_list_head__close_shm_list_page_12 = $mol_type_enforce<
		ReturnType< $shm_list_page['close_run'] >
		,
		ReturnType< $shm_list_head['close'] >
	>
	type $shm_list_head__settings_hint_shm_list_page_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_head['settings_hint'] >
	>
	type $shm_list_head__sort_by_shm_list_page_14 = $mol_type_enforce<
		ReturnType< $shm_list_page['sort_by'] >
		,
		ReturnType< $shm_list_head['sort_by'] >
	>
	type $shm_list_head__sort_order_shm_list_page_15 = $mol_type_enforce<
		ReturnType< $shm_list_page['sort_order'] >
		,
		ReturnType< $shm_list_head['sort_order'] >
	>
	type $shm_list_head__sort_options_shm_list_page_16 = $mol_type_enforce<
		ReturnType< $shm_list_page['sort_options'] >
		,
		ReturnType< $shm_list_head['sort_options'] >
	>
	export class $shm_list_page extends $mol_page {
		Head_title( ): ReturnType< ReturnType< $shm_list_page['List_head'] >['Title'] >
		head_content( ): readonly($mol_view_content)[]
		filter( next?: string ): string
		filter_hint( ): string
		Search( ): $mol_search
		add_title( ): string
		add_content( ): readonly($mol_view)[]
		add_run( next?: any ): any
		close_hint( ): string
		close_content( ): readonly($mol_view)[]
		close_run( next?: any ): any
		sort_by( next?: string ): string
		sort_order( next?: string ): string
		sort_options( ): Record<string, string>
		List_head( ): $shm_list_head
		add( next?: any ): any
		close( next?: any ): any
		head( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map